<header class="site-header roboto-text">
  <div class="site-header-left">
    <a href="/" class="nav-logo-container" id="navLogoContainer"
      [class.easter-egg-active]="logoEasterEggActive"
      (mouseenter)="restartLogoAnimation()"
      (click)="onLogoClick($event)">
      <div class="nav-logical">Logica<span id="navL" [class.nav-cursor-active]="logoCursorBlink">l</span></div>
      <div class="nav-suffix-wrapper">
        <div class="nav-suffix">
          <span id="navLine1">{{ logoLine1 }}</span>
          <span id="navLine2">{{ logoLine2 }}</span>
        </div>
      </div>
    </a>
  </div>

  <div class="site-header-mobile-actions">
    <span class="dark-swicth-block">
      <span class="button-cover-dark-mode header-dark-toggle-simple">
        <div class="button" (click)="toggleMode()" title="Přepnout noční režim">
          <svg class="light-icon">
            <use href="assets/icons/light-mode.svg#icon-light"></use>
          </svg>
          <svg class="dark-icon">
            <use href="assets/icons/dark-mode.svg#icon-dark"></use>
          </svg>
        </div>
      </span>
    </span>

    <div id="mobile-nav" (click)="mobileMenuOpen = !mobileMenuOpen" [ngClass]="{ 'active': mobileMenuOpen }"
      title="Menu">
      <svg class="menu-bars" width="28" height="28">
        <use href="assets/icons/bars.svg#icon-bars"></use>
      </svg>
    </div>
  </div>

  <div id="main-navigation-inner-h" [ngClass]="{ 'fixed': isFixed }" class="w3-row main-navigation-inner-h none">
    <nav role="navigation" id="main-menu">
      <h2 class="visually-hidden">Hlavní navigace</h2>
      <ul class="ul-parent ul-parent-main ul-0">
        <li class="li-item li-item-main li-0">
          <a href="/calculator" class="li-link li-link-main" [class.is-active]="isActive('calculator')">{{ "Menu-5" | translate }}</a>
        </li>
        <li class="li-item li-item-main li-0">
          <a [routerLink]="['/video-instruction']" class="li-link li-link-main" [class.is-active]="isActive('navod')">{{ "Menu-1" | translate }}</a>
        </li>
        <li class="li-item li-item-main li-0" [hidden]="('cs'!== translate.currentLang) && ('sk'!== translate.currentLang)">
          <a [routerLink]="['/blog']" class="li-link li-link-main" [class.is-active]="isActive('blog')">{{ "Menu-4" | translate }}</a>
        </li>
        <li class="li-item li-item-main li-0">
          <a [routerLink]="['/']" fragment="tariffs" class="li-link li-link-main"
            [class.is-active]="isActive('tariffs')" (click)="onSectionClick('tariffs')">{{ "Menu-2" | translate }}</a>
        </li>
        <li class="li-item li-item-main li-0">
          <a [routerLink]="['/']" fragment="partners" class="li-link li-link-main"
            [class.is-active]="isActive('partners')" (click)="onSectionClick('partners')">{{ "Menu-6" | translate }}</a>
        </li>
        <li class="li-item li-item-main li-0">
          <a [routerLink]="['/']" fragment="contact" class="li-link li-link-main"
            [class.is-active]="isActive('contact')" (click)="onSectionClick('contact')">{{ "Menu-3" | translate }}</a>
        </li>
      </ul>
    </nav>

    <nav role="navigation" id="main-menu-mobile">
      <ul class="ul-parent ul-parent-main ul-0" role="menu" *ngIf="mobileMenuOpen" @ulSlide>
        <li class="li-item li-item-main li-0">
          <a href="/calculator" class="li-link li-link-main" [class.is-active]="isActive('calculator')">{{ "Menu-5" | translate }}</a>
        </li>
        <li class="li-item li-item-main li-0">
          <a [routerLink]="['/video-instruction']" (click)="hiddenMenu()" class="li-link li-link-main"
            [class.is-active]="isActive('navod')">{{ "Menu-1" | translate }}</a>
        </li>
        <li class="li-item li-item-main li-0" [hidden]="('cs'!== translate.currentLang) && ('sk'!== translate.currentLang)">
          <a [routerLink]="['/blog']" (click)="hiddenMenu()" class="li-link li-link-main"
            [class.is-active]="isActive('blog')">{{ "Menu-4" | translate }}</a>
        </li>
        <li class="li-item li-item-main li-0">
          <a [routerLink]="['/']" fragment="tariffs" class="li-link li-link-main"
            [class.is-active]="isActive('tariffs')" (click)="onSectionClick('tariffs')">{{ "Menu-2" | translate }}</a>
        </li>
        <li class="li-item li-item-main li-0">
          <a [routerLink]="['/']" fragment="partners" class="li-link li-link-main"
            [class.is-active]="isActive('partners')" (click)="onSectionClick('partners')">{{ "Menu-6" | translate }}</a>
        </li>
        <li class="li-item li-item-main li-0">
          <a [routerLink]="['/']" fragment="contact" class="li-link li-link-main"
            [class.is-active]="isActive('contact')" (click)="onSectionClick('contact')">{{ "Menu-3" | translate }}</a>
        </li>
      </ul>
    </nav>
  </div>

  <div class="site-header-right no-mobil-user-login">
    <ng-container *ngIf="user">
      <ng-container *ngIf="user.is_anonymous; then thenBlockLogin; else BlockLogout"></ng-container>
      <ng-template #thenBlockLogin>
        <div class="btn-group user-menu">
          <a href="{{urlData}}/users/login">
            <button class="btn btn-login-user" id="btn-login-users">
              <span class="user-login">
                <span id="label-login-btn">{{ "WebLogin" | translate }}</span>
                <svg class="user-login">
                  <use href="assets/icons/user.svg#icon-user-login"></use>
                </svg>
              </span>
            </button>
          </a>
          <a href="{{ urlData }}/users/register/">
            <button class="btn" id="btn-registration">
              <span id="label-registration-btn">{{ "WebRegistration" | translate }}</span>
              <span class="svg-container">
                <svg class="user-registration">
                  <use href="assets/icons/user-add.svg#icon-user-registration"></use>
                </svg>
              </span>
            </button>
          </a>
        </div>
      </ng-template>
      <ng-template #BlockLogout>
        <div class="btn-group user-menu" dropdown>
          <button [ngClass]="{ 'btn-login-avatar': user && user.avatarBase64 }"
            id="button-animated" dropdownToggle type="button" class="btn dropdown-toggle"
            aria-controls="dropdown-animated">
            {{ createAuthorString() }}
            <span class="caret"></span>
          </button>
          <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu"
            aria-labelledby="button-animated">
            <li role="menuitem" style="cursor: pointer;">
              <div class="dropdown-item" (click)="logout()">
                {{ "WebLogout" | translate }}
              </div>
            </li>
          </ul>
        </div>
      </ng-template>
    </ng-container>

    <div class="header-actions-divider"></div>

    <div class="btn-group" dropdown [autoClose]="true">
      <div class="dropdown-wrapper">
        <button id="button-animated-lang" class="language-button" dropdownToggle type="button"
          aria-controls="dropdown-animated-lang">
          <span class="language-label">{{ translate.currentLang }}</span>
        </button>
        <ul id="dropdown-animated-lang" *dropdownMenu
          class="dropdown-menu dropdown-menu-language custom-grid" role="menu"
          aria-labelledby="button-animated-lang">
          <ng-container *ngFor="let language of translate.getLangs()">
            <li role="menuitem" *ngIf="language !== translate.currentLang">
              <div class="dropdown-item" (click)="switchLang(language);">
                <img src="/assets/flags/{{ language }}.svg" height="24px"
                  style="float: left; height: 24px" />
                <span style="padding: 5px">{{ language }}</span>
              </div>
            </li>
          </ng-container>
        </ul>
      </div>
    </div>

    <span class="dark-swicth-block">
      <span class="button-cover-dark-mode header-dark-toggle-simple">
        <div class="button" id="button-13" (click)="toggleMode()" title="Přepnout noční režim">
          <svg class="light-icon">
            <use href="assets/icons/light-mode.svg#icon-light"></use>
          </svg>
          <svg class="dark-icon">
            <use href="assets/icons/dark-mode.svg#icon-dark"></use>
          </svg>
        </div>
      </span>
    </span>
  </div>

  <div class="mobil-user-login">
    <ng-container *ngIf="user">
      <ng-container *ngIf="user.is_anonymous; then thenBlockLoginMobile; else BlockLogoutMobile"></ng-container>
      <ng-template #thenBlockLoginMobile>
        <span>
          <div class="btn-group user-menu">
            <a href="{{ urlData }}/users/login" (click)="clear()">
              <button class="btn btn-login-user">
                <span class="user-login">
                  <span id="label-login-btn">{{ "WebLogin" | translate }}</span>
                  <span class="svg-container">
                    <svg class="user-login">
                      <use href="assets/icons/user.svg#icon-user-login"></use>
                    </svg>
                  </span>
                </span>
              </button>
            </a>
            <a href="{{ urlData }}/users/register/">
              <button class="btn" id="btn-registration">
                <span id="label-registration-btn">{{ "WebRegistration" | translate }}</span>
                <span class="svg-container">
                  <svg class="user-registration">
                    <use href="assets/icons/user-add.svg#icon-user-registration"></use>
                  </svg>
                </span>
              </button>
            </a>
          </div>
        </span>
      </ng-template>
      <ng-template #BlockLogoutMobile>
        <span>
          <div class="btn-group user-menu" dropdown>
            <button [ngClass]="{ 'btn-login-avatar': user && user.avatarBase64 }"
              id="button-animated-mobile" dropdownToggle type="button" class="btn dropdown-toggle"
              aria-controls="dropdown-animated-mobile">
              {{ createAuthorString() }}
              <span class="caret"></span>
            </button>
            <ul id="dropdown-animated-mobile" *dropdownMenu class="dropdown-menu"
              aria-labelledby="button-animated-mobile">
              <li role="menuitem" style="cursor: pointer;">
                <div class="dropdown-item" (click)="logout()">
                  {{ "WebLogout" | translate }}
                </div>
              </li>
            </ul>
          </div>
        </span>
      </ng-template>
    </ng-container>

    <div class="btn-group" dropdown [autoClose]="true">
      <button class="language-button" dropdownToggle type="button">
        <span class="language-label">{{ translate.currentLang }}</span>
      </button>
      <ul *dropdownMenu class="dropdown-menu dropdown-menu-language custom-grid" role="menu">
        <ng-container *ngFor="let language of translate.getLangs()">
          <li role="menuitem" *ngIf="language !== translate.currentLang">
            <div class="dropdown-item" (click)="switchLang(language);">
              <img src="/assets/flags/{{ language }}.svg" height="24px"
                style="float: left; height: 24px" />
              <span style="padding: 5px">{{ language }}</span>
            </div>
          </li>
        </ng-container>
      </ul>
    </div>
  </div>
</header>
